import React from 'react';

export const SpinnerFallback: React.FC<{ label?: string }> = ({ label }) => (
  <div className="fixed inset-0 flex items-center justify-center pointer-events-none">
    <div className="flex flex-col items-center gap-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-2xl border-2 border-dashed border-gray-300 shadow">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-yellow-400 border-t-transparent" />
      {label && <span className="text-xs font-bold text-gray-600 tracking-wide">{label}</span>}
    </div>
  </div>
);
